import { Injectable } from '@angular/core';
import { RequestOptions, Response, URLSearchParams } from '@angular/http';

import { AuthHttp } from '../../../../../common/index';
import { AppSettings } from '../../../../../settings/index';

@Injectable()
export class HolidayService {
    constructor(private http: AuthHttp) { }

    getIncomingHolidays(startDate: Date) {
        let params: URLSearchParams = new URLSearchParams();
        params.set("startDate", startDate.toUTCString());

        let options: RequestOptions = new RequestOptions({ search: params });
        return this.http.get(AppSettings.apiEndpoint + "Holiday/GetIncomingHolidays", options)
            .map((response: Response) => response.json());
    }

    getAllDriverByName(driverName: string) {        
        let params: URLSearchParams = new URLSearchParams();
        params.set("driverName", driverName);

        let options: RequestOptions = new RequestOptions({ search: params });
        return this.http.get(AppSettings.apiEndpoint + "OPDriver/SelectDriversByName", options)
            .map((response: Response) => response.json());
    }

    getAllDrivers(ownerCode: string) {  
        let params: URLSearchParams = new URLSearchParams();
        params.set("ownerCode", ownerCode);

        let options: RequestOptions = new RequestOptions({ search: params });      
        return this.http.get(AppSettings.apiEndpoint + "OPDriver/SelectDrivers", options)
            .map((response: Response) => response.json());
    }
}


// WEBPACK FOOTER //
// ./src/app/infrastructure/services/transaction/op/outbound/order/holiday.service.ts